/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React, { useCallback } from "react";

import {
  usePlayerAdvertisementCue,
  usePlayerTimer,
} from "../../../../../BasePlayer";

import "./AdvertisementMarks.scss";

interface AdvertisementMarksProps {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}

export const AdvertisementMarks = (props: AdvertisementMarksProps) => {
  const { onMouseEnter, onMouseLeave } = props;

  const { cuePoints } = usePlayerAdvertisementCue();

  const {
    timer: { duration },
  } = usePlayerTimer();

  const haveMarks = cuePoints.length > 0;
  const isValidDuration = Boolean(duration && duration !== Infinity);

  const renderCuePoints = useCallback(() => {
    return cuePoints.map((pointSeconds) => {
      const style: React.CSSProperties = {};

      switch (true) {
        // pre roll
        case pointSeconds === 0: {
          style.left = "0";
          break;
        }
        // post roll
        case pointSeconds === -1: {
          style.right = "0";
          break;
        }
        // mid roll
        default: {
          style.left = `${(pointSeconds * 100) / duration}%`;
        }
      }

      return (
        <div
          key={`cue-${pointSeconds}`}
          className="AdvertisementMarks__Mark"
          style={style}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      );
    });
  }, [cuePoints, duration, onMouseEnter, onMouseLeave]);

  if (!haveMarks) {
    return <></>;
  }

  return (
    <div className="AdvertisementMarks">
      {isValidDuration && renderCuePoints()}
    </div>
  );
};
